fragment AccountForCoreEntityFragment on Account {
    id
    name
    avatarUrl
    htmlUrlPath
    description
    postalAddresses {
        primary {
            location {
                formattedAddress
            }
        }
    }
    hasDuplicates
    phones {
        primary {
            value {
                id
                numberFormatted
                extension
                numberFormattedWithCountryCode
            }
        }
    }
}
